import React, { useState } from "react";
import Layout from "../../components/Layout/layout";
import axios from "axios";
import { baseURL } from "../axiosInstance";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import img1 from "../../assets/sbiscreenshots/1.png.png";
import img2 from "../../assets/sbiscreenshots/2.png.png";
import img3 from "../../assets/sbiscreenshots/3.png.png";
import img4 from "../../assets/sbiscreenshots/4.png.png";
import img5 from "../../assets/sbiscreenshots/5.png.png";

const Registration = () => {
  const [isLastStep, setIsLastStep] = useState(false);

  const handleClick = () => {
    setIsLastStep(!isLastStep);
  };

  const [first, setFirst] = useState("");
  const [middle, setMiddle] = useState("");
  const [last, setLast] = useState("");
  const [registrationId, setRegistrationId] = useState("");
  const [title, setTitle] = useState("");
  const [designation, setDesignation] = useState("");
  const [institution, setInstitution] = useState("");
  const [billingAddress, setBillingAddress] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [contact, setContact] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [sendingData, setSendingData] = useState(false);

  const [file, setFile] = useState(null);

  const [filePreview, setFilePreview] = useState(null);
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      try {
        const fileURL = URL.createObjectURL(selectedFile);
        setFile(selectedFile);
        setFilePreview(fileURL);
      } catch (error) {
        console.error("Failed to create object URL", error);
      }
    } else {
      console.error("No file selected or file is invalid");
    }
  };

  const validateEmail = (value) => {
    // Regular expression for basic email validation
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(value);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setEmail(value);

    if (!validateEmail(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const [ID, setID] = useState("");
  const [food, setFood] = useState([false, false, false, false]);
  const [isetMembershipNumber, setIsetMemberShipNumber] = useState("");
  const [studentIdCopy, setStudentIdCopy] = useState("");
  const [accompanyPersonId, setAccompanyPerson] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const handleCheckboxChange = (index) => {
    let newFood = [];
    for (let i = 0; i < food.length; i++) {
      if (i == index) {
        if (food[i] == false) {
          newFood.push(true);
        } else {
          newFood.push(false);
        }
      } else {
        newFood.push(false);
      }
    }

    console.log(newFood);
    setFood(newFood);
  };

  const [registrationStatus, setRegistrationStatus] = useState([
    {
      verdict: false,
      nameId: "ISET member (SAARC)",
      fee: "INR 11800 (Including 18% GST)",
    },
    {
      verdict: false,
      nameId: "Non-ISET member (SAARC)",
      fee: "INR 14160 (Including 18% GST)",
    },
    {
      verdict: false,
      nameId: "Bonafide Student (SAARC)",
      fee: "INR 7080 (Including 18% GST)",
    },
    {
      verdict: false,
      nameId: "Accompanying Person (SAARC)",
      fee: "INR 7080 (Including 18% GST)",
    },
    {
      verdict: false,
      nameId: "Foreign Delegate",
      fee: "INR 59109 (Including 18% GST)",
    },
    {
      verdict: false,
      nameId: "Student (Foreign)",
      fee: "INR 29552 (Including 18% GST)",
    },
    {
      verdict: false,
      nameId: "Accompanying Person (Foreign)",
      fee: "INR 29552 (Including 18% GST)",
    },
    {
      verdit: false,
      nameId: "Theme Speakers (ISET member, From SAARC Country)",
      fee: "INR 10620 (Including 18% GST)",
    },
    {
      verdit: false,
      nameId: "Theme Speakers (Non SAARC Country)",
      fee: "INR 49253 (Including 18% GST)",
    },
    {
      verdit: false,
      nameId: "Theme Speakers (Non-ISET member, SAARC Country)",
      fee: "INR 12980 (Including 18% GST)",
    },
  ]);
  const handleregistrationStatusChange = (index) => {
    let arr = [];
    for (let i = 0; i < registrationStatus.length; i++) {
      if (i == index) {
        if (registrationStatus[i].verdict == false) {
          arr.push({
            verdict: true,
            nameId: registrationStatus[i].nameId,
            fee: registrationStatus[i].fee,
          });
        } else {
          arr.push({
            verdict: false,
            nameId: registrationStatus[i].nameId,
            fee: registrationStatus[i].fee,
          });
        }
      } else {
        arr.push({
          verdict: false,
          nameId: registrationStatus[i].nameId,
          fee: registrationStatus[i].fee,
        });
      }
    }
    setRegistrationStatus(arr);
  };

  const [submitStatus, setSubmitStatus] = useState(false);

  const verifyRegistrationId = (e, regCategory) => {
    const getIt = async () => {
      e.preventDefault();
      try {
        const response = await axios.get(
          `${baseURL}/user/admin/verifyAccompanyingPerson`,
          {
            params: {
              id: registrationId,
              regCategory: regCategory,
            },
          }
        );
        if (response.data.success == true) {
          toast.success(response.data.message);
          setSubmitStatus(true);
          setAccompanyPerson(registrationId);
        } else {
          toast.error(response.data.message);
          setSubmitStatus(false);
        }

        console.log(response);
      } catch (error) {
        console.log(error);
        setSubmitStatus(false);
        if (error.response.data.message.split(" ")[0] == "Cast") {
          toast.error("registeration Id is wrong");
        } else {
          toast.error(error.response.data.message);
        }
      }
    };
    getIt();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSendingData(true);

    if (
      submitStatus == false &&
      (registrationStatus[3].verdict == true ||
        registrationStatus[6].verdict == true)
    ) {
      toast.error(
        "Accompanying person entered registraionId must be correct and verified click on verify Id"
      );
      return;
    }

    if (!first) {
      toast.error("First Name is required");
      return;
    }
    if (!last) {
      toast.error("Last Name is required");
      return;
    }
    if (!email) {
      toast.error("Email is required");
      return;
    }
    if (!validateEmail(email)) {
      toast.error("Invalid email format");
      return;
    }
    if (!billingAddress) {
      toast.error("Billing Address is required");
      return;
    }
    if (!ID) {
      toast.error(
        "In case of existing Author (Enter Full Length Paper ID) or else enter 0"
      );
      return;
    }
    if (!title) {
      toast.error("Title is required");
      return;
    }
    if (!designation) {
      toast.error("Designation is required");
      return;
    }
    if (!institution) {
      toast.error("Institution is required");
      return;
    }
    if (!transactionId) {
      toast.error("Transaction ID is required");
      return;
    }
    if (food.every((item) => !item)) {
      toast.error("At least one food preference must be selected");
      return;
    }
    if (registrationStatus.every((item) => !item.verdict)) {
      toast.error("At least one Registration Category must be selected");
      return;
    }

    try {
      const selectedFoodIndex = food.findIndex((item) => item);
      const selectedFood =
        selectedFoodIndex === 0
          ? "Veg"
          : selectedFoodIndex === 1
          ? "Non-Veg"
          : selectedFoodIndex === 2
          ? "Jain"
          : selectedFoodIndex === 3
          ? "Vegan"
          : "";

      const selectedRegistrationStatus = registrationStatus.find(
        (item) => item.verdict
      );
      const registrationCategory = selectedRegistrationStatus
        ? selectedRegistrationStatus.nameId
        : "";
      const registrationFee = selectedRegistrationStatus
        ? selectedRegistrationStatus.fee
        : "";

      // Create a FormData object to handle file upload
      const formData = new FormData();
      formData.append("receiptImage", file);
      formData.append("name[first]", first);
      formData.append("name[middle]", middle);
      formData.append("name[last]", last);
      formData.append("title", title);
      formData.append("designation", designation);
      formData.append("institution", institution);
      formData.append("billingAddress", billingAddress);
      formData.append("email", email);
      formData.append("foodPreference", selectedFood);
      formData.append("paperId", ID);
      formData.append("registrationCategory", registrationCategory);
      formData.append("isetMembershipNumber", isetMembershipNumber);
      formData.append("studentIdCopy", studentIdCopy);
      formData.append("registrationFee", registrationFee);
      formData.append("contact", contact);
      formData.append("transactionId", transactionId);

      const response = await axios.post(`${baseURL}/user/register`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(response);
      toast.success("Thank You For Registration!");
      setSendingData(false);
      // Handle post-registration logic
    } catch (error) {
      console.error("Error during registration:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred during registration. Please try again.");
      }

      setSendingData(false);
      navigate(location.pathname, { replace: true });
    }
  };

  return (
    <Layout>
      <div className="bg-[#D7DDE1] py-10 ">
        <div className="w-full md:w-3/4 px-10 md:px-20 py-8 border-2 bg-[#f5f4f4] z-20 mb-[5vh] relative mx-auto">
          <div className="font-bold text-4xl text-[#1F7E95] mb-10">
            REGISTRATION
          </div>

          <div class="text-lg mb-10 text-gray-500 prose flex justify-center">
            Fill in all the details required before selecting the appropriate
            category of registration fee. Payment confirmation will be sent
            along with the invoice, registration ID and QR code within 24 to 48
            hours of payment (after confirming the receipt of money at the
            organizers end). This registration ID or QR code must be kept with
            you and the same will be used at the time of collecting the
            registration kit, during the conference.
          </div>

          <div className="w-full flex gap-6">
            <div
              onClick={handleClick}
              className={`${
                isLastStep === false
                  ? "bg-orange-500 text-white"
                  : "bg-white text-orange-500"
              } text-base px-3 py-3 rounded-md shadow-lg cursor-pointer`}
            >
              Participant Details
            </div>
          </div>

          {/* <div className="mt-5 font-serif text-purple-400 font-bold" >Admin ?  <Link to="/adminLogin"><span className="text-sm underline cursor-pointer text-blue-600">Login Here</span></Link> </div> */}

          {!isLastStep && (
            <div className="w-full mt-[3rem]">
              <ToastContainer style={{ marginTop: "50px" }} />
              <form className="flex flex-col gap-6">
                <div className="w-full flex justify-between">
                  <div className="w-[32%]">
                    <input
                      value={first}
                      onChange={(e) => setFirst(e.target.value)}
                      type="text"
                      className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                      placeholder="First Name"
                    />
                  </div>
                  <div className="w-[32%]">
                    <input
                      value={middle}
                      onChange={(e) => setMiddle(e.target.value)}
                      type="text"
                      className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                      placeholder="Middle Name"
                    />
                  </div>
                  <div className="w-[32%]">
                    <input
                      value={last}
                      onChange={(e) => setLast(e.target.value)}
                      type="text"
                      className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                      placeholder="Last Name"
                    />
                  </div>
                </div>
                <div className="w-full">
                  <input
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    type="text"
                    name=""
                    id=""
                    className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                    placeholder="Title (Prof./Dr./Mr./Mrs./Ms.)"
                  />
                </div>
                <div className="w-full">
                  <input
                    value={designation}
                    onChange={(e) => setDesignation(e.target.value)}
                    type="text"
                    name=""
                    id=""
                    className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                    placeholder="Designation"
                  />
                </div>
                <div className="w-full">
                  <input
                    value={institution}
                    onChange={(e) => setInstitution(e.target.value)}
                    type="text"
                    name=""
                    id=""
                    className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                    placeholder="Institution"
                  />
                </div>
                <div className="w-full">
                  <textarea
                    value={billingAddress}
                    onChange={(e) => setBillingAddress(e.target.value)}
                    className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                    name=""
                    id=""
                    cols="30"
                    rows="3"
                    placeholder="Complete Billing Address"
                  ></textarea>
                </div>
                <div className="w-full">
                  <input
                    value={email}
                    onChange={handleChange}
                    type="email"
                    name=""
                    id=""
                    className={`w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500 ${
                      emailError ? "border-red-500" : ""
                    }`}
                    placeholder="Email address"
                  />
                  {emailError && (
                    <p className="text-red-500 text-sm mt-1">{emailError}</p>
                  )}
                </div>

                <div className="w-full">
                  <span className="text-gray-500">Enter Contact Number</span>
                  <div className="custom-phone-input">
                    <PhoneInput
                      placeholder="Enter Contact Number"
                      country={"us"}
                      value={contact}
                      onChange={(phone) => setContact(phone)}
                      inputClass="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder:text-gray-500"
                      buttonClass="bg-neutral-200 border-0 outline-none"
                    />
                  </div>
                </div>

                <div className="w-full flex flex-col md:flex-row md:gap-24">
                  <div className="text-gray-500 p-3">Food Preference</div>
                  <div className="flex gap-2 md:gap-8 md:flex-row flex-col">
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={food[0]}
                        onChange={() => handleCheckboxChange(0)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="Veg"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">Veg</span>
                    </div>
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={food[1]}
                        onChange={() => handleCheckboxChange(1)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name=""
                        id=""
                      />
                      <span className="text-gray-500 text-lg">Non-Veg</span>
                    </div>
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={food[2]}
                        onChange={() => handleCheckboxChange(2)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name=""
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        Jain/No Onion and Garlic
                      </span>
                    </div>
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={food[3]}
                        onChange={() => handleCheckboxChange(3)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name=""
                        id=""
                      />
                      <span className="text-gray-500 text-lg">Vegan</span>
                    </div>
                  </div>
                </div>

                <div className="w-full flex flex-col">
                  <div>
                    In case of existing Author (Enter Full Length Paper ID) or
                    else enter 0.
                  </div>
                  <input
                    value={ID}
                    onChange={(e) => setID(e.target.value)}
                    type="text"
                    name=""
                    id=""
                    className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                    placeholder="ID"
                  />
                </div>

                <div className="w-full flex flex-col md:flex-row md:gap-24">
                  <div className="text-gray-500 p-3">Registration Category</div>
                  <div className="flex gap-2 md:gap-8 md:flex-row flex-col flex-wrap">
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={registrationStatus[0].verdict}
                        onChange={() => handleregistrationStatusChange(0)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="ISET member (SAARC)"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        ISET member (SAARC)
                      </span>
                    </div>
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={registrationStatus[1].verdict}
                        onChange={() => handleregistrationStatusChange(1)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="Non-ISET member (SAARC)"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        Non-ISET member (SAARC)
                      </span>
                    </div>
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={registrationStatus[2].verdict}
                        onChange={() => handleregistrationStatusChange(2)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="Bonafide Student (SAARC)"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        Bonafide Student (SAARC)
                      </span>
                    </div>
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={registrationStatus[3].verdict}
                        onChange={() => handleregistrationStatusChange(3)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="Accompanying Person (SAARC)"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        Accompanying Person (SAARC)
                      </span>
                    </div>

                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={registrationStatus[4].verdict}
                        onChange={() => handleregistrationStatusChange(4)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="Foreign Delegate"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        Foreign Delegate
                      </span>
                    </div>

                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={registrationStatus[5].verdict}
                        onChange={() => handleregistrationStatusChange(5)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="Student (Foreign)"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        Student (Foreign)
                      </span>
                    </div>

                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={registrationStatus[6].verdict}
                        onChange={() => handleregistrationStatusChange(6)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="Accompanying Person (Foreign)"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        Accompanying Person (Foreign)
                      </span>
                    </div>
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={registrationStatus[7].verdict}
                        onChange={() => handleregistrationStatusChange(7)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="Theme Speakers (ISET member, From SAARC Country)"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        Theme Speakers (ISET member, From SAARC Country)
                      </span>
                    </div>
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={registrationStatus[8].verdict}
                        onChange={() => handleregistrationStatusChange(8)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="Theme Speakers (Non SAARC Country)"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        Theme Speakers (Non SAARC Country)
                      </span>
                    </div>
                    <div className="flex bg-white rounded-lg shadow-lg items-center px-4 py-1 gap-4">
                      <input
                        checked={registrationStatus[9].verdict}
                        onChange={() => handleregistrationStatusChange(9)}
                        className="w-4 h-4 accent-orange-500"
                        type="checkbox"
                        name="Theme Speakers (Non-ISET member, SAARC Country)"
                        id=""
                      />
                      <span className="text-gray-500 text-lg">
                        Theme Speakers (Non-ISET member, SAARC Country)
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  {registrationStatus.map((ele, index) => {
                    if (ele.verdict == true) {
                      return (
                        <div>
                          <div className="text-red-600 font-bold text-lg shadow-md ">{`Registration Fee is ${ele.fee}`}</div>
                          <div>
                            <div className="flexx flex-col items-center justify-center">
                              <div>
                                {registrationStatus[6].verdict == true && (
                                  <div className="w-full p-2">
                                    <h1 className="font-bold text-2xl my-2">
                                      Registration ID for each delegate will be
                                      provided in the registration confirmation
                                      email within 24 to 48 hours of payment.
                                      This Registration ID has to be entered
                                      below while registering for Accompanying
                                      Person.
                                    </h1>
                                    <input
                                      value={registrationId}
                                      onChange={(e) =>
                                        setRegistrationId(e.target.value)
                                      }
                                      type="text"
                                      name=""
                                      id=""
                                      className="w-full  bg-neutral-200 mt-2 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                                      placeholder="Registration ID of the Person accompanying with (provided at valid email address) "
                                    />
                                    <button
                                      className="bg-green-400 text-md font-bold p-4 rounded-lg border-green-900 border-2 mt-2 hover:bg-green-600 text-white"
                                      onClick={(e) =>
                                        verifyRegistrationId(
                                          e,
                                          registrationStatus[6].nameId
                                        )
                                      }
                                    >
                                      Verify Id
                                    </button>
                                  </div>
                                )}
                              </div>

                              <div>
                                {registrationStatus[3].verdict == true && (
                                  <div className="w-full">
                                    <h1 className="font-bold text-2xl my-2">
                                      Registration ID for each delegate will be
                                      provided in the registration confirmation
                                      email within 24 to 48 hours of payment.
                                      This Registration ID has to be entered
                                      below while registering for Accompanying
                                      Person.
                                    </h1>
                                    <input
                                      value={registrationId}
                                      onChange={(e) =>
                                        setRegistrationId(e.target.value)
                                      }
                                      type="email"
                                      name=""
                                      id=""
                                      className="w-full bg-neutral-200 mt-2  p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                                      placeholder="Registration Id  of The Person Accompanied (provided at valid email address of Accompanied Person) "
                                    />
                                    <button
                                      className="bg-green-400 text-md font-bold p-4 rounded-lg border-green-900 border-2 mt-2 hover:bg-green-600 text-white"
                                      onClick={(e) =>
                                        verifyRegistrationId(
                                          e,
                                          registrationStatus[3].nameId
                                        )
                                      }
                                    >
                                      Verify Id
                                    </button>
                                  </div>
                                )}
                              </div>

                              <h1 className="text-2xl mt-2 ml-2 font-bold">
                                Steps For Payment{" "}
                                <span className="font-light">
                                  (find the pay button below)
                                </span>
                              </h1>
                              <img
                                className=" w-[800px] m-2 border-2 border-black object-fill h-[400px] cover"
                                src={img1}
                              ></img>
                              <strong>
                                Step 1. Go to "Other Institutions"
                              </strong>
                            </div>
                            <div>
                              <img
                                className=" w-[800px] m-2 border-2 border-black object-fill h-[400px] cover"
                                src={img2}
                              ></img>
                              <strong>
                                Step 2. Filter By State and Select "Assam"
                              </strong>
                            </div>
                            <div>
                              <img
                                className=" w-[800px] m-2 border-2 border-black object-fill h-[400px] cover"
                                src={img3}
                              ></img>
                              <strong>Step 3. Click on 8Icragee</strong>
                            </div>
                            <div>
                              <img
                                className=" w-[800px] m-2 border-2 border-black object-fill h-[400px] cover"
                                src={img4}
                              ></img>
                              <strong>
                                Step 4. Fill in Your Valid Category
                              </strong>
                            </div>
                            <div>
                              <img
                                className=" w-[800px] m-2 border-2 border-black object-fill h-[400px] cover"
                                src={img5}
                              ></img>
                              <strong>
                                Step 5. Fill the required Details and proceed
                                for payment
                              </strong>
                            </div>
                          </div>

                          {/* <button className="p-2 mt-2 border-2 border-green-600 text-lg font-bold text-white bg-green-400 hover:bg-green-600 rounded-lg"><a href="https://www.onlinesbi.sbi/sbicollect/icollecthome.htm">Proceed to Pay</a></button> */}
                          {/* <div className="w-full flex flex-col mt-2">
                            <input
                              value={transactionId}
                              onChange={(e) => setTransactionId(e.target.value)}

                              id=""
                              className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                              placeholder="Transaction-Id"
                              type="text"
                              name="transactionId"

                            />

                          </div> */}
                          <div className="w-full">
                            <span className="text-[red] text-base font-medium">
                              Payment confirmation will be sent along with the
                              invoice, registration ID and QR code within 24 to
                              48 hours of payment (after confirming the receipt
                              of money at the organizers end). This registration
                              ID or QR code must be kept with you and the same
                              will be used at the time of collecting the
                              registration kit, during the conference.
                            </span>
                          </div>
                          <button className="p-2 mt-2 border-2 border-green-600 text-lg font-bold text-white bg-green-400 hover:bg-green-600 rounded-lg">
                            <a
                              href="https://www.onlinesbi.sbi/sbicollect/icollecthome.htm"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Proceed to Pay
                            </a>
                          </button>
                        </div>
                      );
                    }
                  })}
                </div>

                <div>
                  {(registrationStatus[2].verdict == true ||
                    registrationStatus[5].verdict == true) && (
                    <div className="w-full">
                      <h1 className="text-2xl font-bold mx-2">
                        Students must Carry Id cards with them at time of event
                        for Verification
                      </h1>
                      <input
                        value={studentIdCopy}
                        onChange={(e) => setStudentIdCopy(e.target.value)}
                        type="email"
                        name=""
                        id=""
                        className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                        placeholder="Valid Student ID Card Number should be entered here"
                      />
                    </div>
                  )}
                </div>

                <div>
                  {registrationStatus[0].verdict == true && (
                    <div className="w-full">
                      <input
                        value={isetMembershipNumber}
                        onChange={(e) =>
                          setIsetMemberShipNumber(e.target.value)
                        }
                        type="email"
                        name=""
                        id=""
                        className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                        placeholder="ISET Membership Number"
                      />
                    </div>
                  )}
                </div>

                <div className="mb-4">
                  <label
                    className="block text-gray-700 text-sm font-bold mb-2"
                    htmlFor="receipt"
                  >
                    Upload bank confirmation (in Image Format)
                  </label>
                  <div className="flex items-center justify-center w-full">
                    <label className="flex flex-col w-full h-32 border-4 border-dashed hover:bg-gray-100 hover:border-gray-300">
                      <div className="flex flex-col cursor-pointer items-center justify-center pt-7">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-12 h-12 text-gray-400 group-hover:text-gray-600"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V8a1 1 0 00-.293-.707l-4-4A1 1 0 0012 3H4zm5 3a1 1 0 011-1h2a1 1 0 011 1v1h2v3h-6v-2h3v1h-2V6H9zm-2 8a1 1 0 011-1h4a1 1 0 110 2H8a1 1 0 01-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <p className="pt-1 text-sm tracking-wider text-gray-400 group-hover:text-gray-600">
                          Attach a file
                        </p>
                      </div>
                      <input
                        type="file"
                        className="opacity-0 cursor-pointer"
                        onChange={handleFileChange}
                      />
                    </label>
                  </div>
                  {filePreview && (
                    <div className="mt-4">
                      <img
                        src={filePreview}
                        alt="Receipt Preview"
                        className="w-full h-auto"
                      />
                    </div>
                  )}
                </div>
                <div>
                  <div className="w-full">
                    <input
                      value={transactionId}
                      onChange={(e) => setTransactionId(e.target.value)}
                      type="text"
                      name=""
                      id=""
                      className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                      placeholder="SBCollect Reference Number (After Successful Payment)"
                    />
                  </div>
                </div>

                <div className="w-full flex justify-end mt-[2rem]">
                  <button
                    type="submit"
                    className={`w-full md:w-[10rem] bg-white py-3 px-6 rounded-lg shadow-xl transition-all ${
                      transactionId.length >= 8 && file != null
                        ? "hover:bg-gray-100"
                        : "cursor-not-allowed "
                    }`}
                    onClick={handleSubmit}
                    disabled={
                      transactionId.length < 8 ||
                      file == null ||
                      sendingData === true
                    }
                  >
                    <span
                      className={`${
                        transactionId.length >= 8 && file != null
                          ? "text-orange-500"
                          : "text-gray-700"
                      }`}
                    >
                      Submit
                    </span>
                    <img src="" alt="" />
                  </button>
                </div>
              </form>
            </div>
          )}
          {/* {isLastStep && (
            <div className="w-full mt-[3rem]">
              <div className="w-full">
                <span className="text-orange-500 font-semibold text-lg">
                  For SAARC Countries
                </span>
              </div>
              <div className="w-full flex flex-col gap-4">
                <div className="w-full flex flex-col md:flex-row justify-between mt-[2rem] gap-6">
                  <div className="w-full md:w-[45%] px-6 py-7 flex flex-col gap-6 rounded-md shadow-lg bg-white">
                    <div className="w-full flex gap-4">
                      <input
                        className="accent-orange-500"
                        type="checkbox"
                        name=""
                        id=""
                      />
                      <span className="text-gray-500 font-semibold">
                        ISET Member
                      </span>
                    </div>
                    <div className="w-full text-orange-500 font-semibold">
                      INR 9000
                    </div>
                    <div className="w-full">
                      <input
                        type="text"
                        className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                        placeholder="First Name"
                      />
                    </div>
                  </div>
                  <div className=" w-full md:w-[45%] px-6 py-7 flex flex-col gap-6 rounded-md shadow-lg bg-white">
                    <div className="w-full flex gap-4">
                      <input
                        className="accent-orange-500"
                        type="checkbox"
                        name=""
                        id=""
                      />
                      <span className="text-gray-500 font-semibold">
                        Bonafide student
                      </span>
                    </div>
                    <div className="w-full text-orange-500 font-semibold">
                      INR 5000
                    </div>
                    <div className="w-full">
                      <input
                        type="text"
                        className="w-full bg-neutral-200 p-3 border-0 outline-none rounded-md text-gray-600 placeholder-gray-500"
                        placeholder="First Name"
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full flex flex-col md:flex-row justify-between mt-[0.8rem] gap-6">
                  <div className="w-full md:w-[45%] px-6 py-7 flex flex-col gap-6 rounded-md shadow-lg bg-white">
                    <div className="w-full flex gap-4">
                      <input
                        className="accent-orange-500"
                        type="checkbox"
                        name=""
                        id=""
                      />
                      <span className="text-gray-500 font-semibold">
                        Non-ISET Member
                      </span>
                    </div>
                    <div className="w-full text-orange-500 font-semibold">
                      INR 11000
                    </div>
                  </div>
                  <div className="w-full md:w-[45%] px-6 py-7 flex flex-col gap-6 rounded-md shadow-lg bg-white">
                    <div className="w-full flex gap-4">
                      <input
                        className="accent-orange-500"
                        type="checkbox"
                        name=""
                        id=""
                      />
                      <span className="text-gray-500 font-semibold">
                        Accompany Person
                      </span>
                    </div>
                    <div className="w-full text-orange-500 font-semibold">
                      INR 5000
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-full mt-[4rem]">
                <span className="text-orange-500 font-semibold text-lg">
                  For Foregin Countries
                </span>
              </div>
              <div className="w-full md:w-[45%] px-6 py-7 flex flex-col gap-6 rounded-md shadow-lg bg-white mt-[2rem]">
                <div className="w-full flex gap-4">
                  <input
                    className="accent-orange-500"
                    type="checkbox"
                    name=""
                    id=""
                  />
                  <span className="text-orange-500 font-semibold">
                    INR 5000
                  </span>
                </div>
              </div>
              <div className="w-full flex justify-end mt-[2rem]">
                <button
                  className="w-full md:w-[15rem] bg-white py-3 px-6 rounded-lg shadow-xl hover:bg-gray-100 transition-all"
                  onClick={handleClick}
                >
                  <span className="text-orange-500">Proceed For Payment</span>
                  <img src="" alt="" />
                </button>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </Layout>
  );
};

export default Registration;
